import { createContext } from 'react';

export const CommonComponentContext = createContext({ clientConfig: {}, upsertSetting: () => {}, configStatuses: () => [], glossary: {}, credentials: { username: null } });